<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <search-form key="claimsSearch1"
                     :inputs="searchInputsEx"
                     class="mb-5"
                     @clear="handleClearClick"
                     @search="handleSearchClick" />
        <hr />
        <div class="row">
            <div class="col">
                <page-size v-model="pageSize"
                           @input="handleSearchClick(searchPayload)" />
            </div>
            <div class="col">
                <order-by v-model="selectedOrderBy"
                          :options="orderByOptionsOverride"
                          @goClick="handleOrderByClick" />
            </div>
        </div>



        <data-list :dataCols="claimsColsOverride"
                   :dataListItems="taskHistoryList"
                   :tableClass="'table table-striped table-sm'"
                   :showCheckbox="false"
                   @dbl-click="handleItemDblClick" />

        <b-pagination align="center"
                      size="md"
                      :total-rows="totalRecords"
                      v-model="pageNumber"
                      :per-page="pageSize"
                      @input="handlePagenationInput" />

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>

import claimsSearch from '@/mixins/claimsSearch.js'

import PageHeader from '@/components/PageHeader.vue'
import DataList from '@/components/DataList.vue'
import PageSize from '@/components/PageSize.vue'
import OrderBy from '@/components/OrderBy.vue'
import SearchForm from '@/components/SearchForm.vue'
import { searchInputs } from '@/ui.config/inputs/taskHistorySearchInputs.js'
import { taskHistoryCols } from '@/ui.config/cols/taskHistoryDetailsCols'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

//  Task History
export default {
    name:'taskHistory',
    mixins: [
        claimsSearch,
    ],
    components: {
        PageHeader,
        DataList,
        PageSize,
        OrderBy,
        SearchForm,
        Loading
    },
    data: () => {
        return {
            pageHeader: {
                title: 'Task History',
            },
            searchInputs: searchInputs,
        }
    },
    beforeMount() {
        this.claimsSearch(null, 1)
        this.fetchTaskTypes()
    },
        computed: {
        searchInputsEx() {

            return searchInputs
        },
        claimsColsOverride() {
            var { taskTypes } = this

            if (taskTypes) {
                searchInputs[3].options = taskTypes
            }
            return taskHistoryCols
        },
        orderByOptionsOverride() {


                return [
                    {
                        id: 0,
                        key: 'DateCreated',
                        label: 'Date'
                    },
                    {
                        id: 2,
                        key: 'ClaimReference',
                        label: 'Claim Reference'
                    }
                ]

           
        }
    },
    methods: {
        // Override mixin
        buildSearchValues(payload) {
            if (payload != null) {
                let { claimReference, relatedReference, username, taskType } = payload

                let criteria = {
                    claimReference: claimReference,
                    relatedReference: relatedReference,
                    userEmail: username,
                    taskTypeId: taskType ? taskType.id : null
                }

                return criteria
            } else {
                return null
            }
        },
        // Override mixin
        buildSearchCriteria(searchValues, pageNumber) {
            let ordering = {
                orderBy: this.orderBy,
                sortDirection: this.sortDirection
            }

            let pages = {
                pageSize: this.pageSize,
                pageNumber: pageNumber
            }

            let criteria = {
                ...searchValues,
                ...ordering,
                ...pages
            }

            return criteria
        },
        // Override mixin
        claimsSearch(searchValues, pageNumber) {
            let criteria = this.buildSearchCriteria(searchValues, pageNumber)
            this.fetchTaskHistoryListPagenated(criteria)
        },
    }
}
</script>

<style>
</style>
